import CustomTag from 'components/CustomTag'
import React from 'react'

const UserStatus = ({ status }) => {
  let colorType
  let tagMessage
  if (status) {
    colorType = 'green'
    tagMessage = 'Active'
  } else if (!status) {
    colorType = 'red'
    tagMessage = 'Inactive'
  }

  return (
    <CustomTag colorType={colorType} message={tagMessage} bordered={false} />
  )
}

export default UserStatus
